import { effect, Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { selectCurrentServiceId, selectFolder, selectServices } from '../../../store/person/person.selectors';
import { FolderFormDataPrintObject, FolderFormObjectDepre } from '@it2go/types';
import { FolderService } from '../../../../../services/folder.service';
import { FormGqlService } from '../../../../../services/form.gql-service';
import { FormGridObject } from '@libs/types/src/services/object-type/form/form.object';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { SERVICE_SETTINGS_FORMS_TYPE_KEY } from '@libs/types/src/services/types/service-settings-forms.type';
import { globalStore } from '../../../../shared/shared.global-service';
import { getSharingFolderIds } from '../../../../../utils/folder.utils';

interface State {
    formsV2: FormGridObject | null;
    folderForms: FolderFormObjectDepre[];
    printFolderFormData: FolderFormDataPrintObject | null;
}

const defaultState: State = {
    formsV2: null,
    folderForms: [],
    printFolderFormData: null,
};

@Injectable()
export class FolderFormsPageStore extends ComponentStoreFactory<State> {

    serviceId = toSignal(this.globalStore!.select(selectCurrentServiceId));

    folder = toSignal(this.globalStore!.select(selectFolder));

    formsSharingIds = toSignal(globalStore!.select(selectServices).pipe(
        map((services) =>
            getSharingFolderIds(this.serviceId(), services, this.folder()?.relatedFolders, SERVICE_SETTINGS_FORMS_TYPE_KEY)),
    ));

    constructor() {
        super(defaultState, inject(Store), inject(FolderService), inject(FormGqlService));

        effect(() => {
            const serviceId = this.serviceId();
            if (serviceId) {
                this.api.getFormsV2({
                    filter: [[{ column: 'serviceId', operator: 'EQ', value: [serviceId.toString()] }]],
                    paging: { page: 1, itemsPerPage: 50 },
                });
            }
        })
    }
}
